import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled(Modal.Body)`
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 10px;
  width: auto;
  height: auto;
  padding: 25px;
  overflow-x: hidden;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const Title = styled.span`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.lightGreen};
  font-weight: 700;
  display: flex;
  flex-direction: column;

  & span {
    color: white;
    font-weight: 400;
  }

  @media (max-width: 468px) {
    font-size: 1rem;
    text-align: center;
  }
`;

export const CloseIcon = styled.span`
  font-size: 22px;
  color: white;
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  gap: 30px;

  @media (max-width: 468px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const ContentImg = styled.img`
  margin-top: -60px;
  width: 40%;

  @media (max-width: 468px) {
    width: 65%;
  }
`;

export const ContentButtons = styled.div`
  display: -webkit-box;
  gap: 10px;
  width: 100%;
`;

export const ContentInfos = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  gap: 50px;

  @media (max-width: 468px) {
    gap: 35px;
  }
`;

export const Button = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 1px solid white;
  background-color: white;
  border-radius: 3px;
  text-decoration: none;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.blue};
  text-align: center;

  &:hover {
    text-decoration: none;
    background-color: ${({ theme }) => theme.colors.blue};
    color: #fff;
    transition: all 0.5s;
  }

  @media (max-width: 468px) {
    padding: 12px;
  }
`;
